module.exports = __webpack_public_path__ + "static/media/2.52eadd19.jpg";